<div class="pill-content">
  <div class="pill-content-progress" [class.margin-right]="hideInsights">
    <div class="pill-content-progress-header">
      <i class="pill-content-progress-header-icon" ngClass="{{titleIcon}}"></i>
      <div class="pill-content-progress-header-title">{{title}}</div>
    </div>
    <div class="pill-content-progress-bar">
      <div class="pill-content-progress-bar-progress" [style.width.%]="progress"
      ></div>
    </div>
  </div>

  @if (!hideInsights) {
    <div class="pill-content-insights">
      <i
        class="pill-content-insights-icon"
        [ngClass]="leadsToIcon"
      ></i>
      <div
        class="pill-content-insights-title"
        [class.request-call]="isOnDemand"
      >{{leadsToText | translate}}</div>
    </div>
  }

  @if (nextTitle && !isOnDemand) {
    <div class="pill-content-progress next">
      <div class="pill-content-progress-header">
        <i class="pill-content-progress-header-icon" ngClass="{{nextTitleIcon}}"></i>
        <div class="pill-content-progress-header-title">{{nextTitle}}</div>
      </div>
      <div class="pill-content-progress-bar fade">
        <div class="pill-content-progress-bar-progress" [style.width.%]="0"></div>
      </div>
    </div>
  }
</div>